import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ConditionalAccessPolicy } from '@microsoft/microsoft-graph-types-beta';
import { LookupItem } from '../../model';
import { mapLookupToObject } from '../../utlize';

@Component({
    selector: 'sway-cap-conditions',
    templateUrl: './cap-conditions.component.html',
    styleUrls: ['./cap-conditions.component.scss', '../../../../../styles/baseline-style.scss'],
})
export class CapConditionsComponent implements OnInit {
    @Input() policy: ConditionalAccessPolicy;
    @Input() readOnly: boolean;
    @Input() form: FormGroup;
    @Input() errorsString: string = '';

    magicField: LookupItem = { name: 'Not configured', value: 'none' };
    includePlatformMagicField = { name: 'Any device', value: 'all' };

    signInRiskLevelsLookup: LookupItem[] = [
        { name: 'High', value: 'high' },
        { name: 'Medium', value: 'medium' },
        { name: 'Low', value: 'low' },
        { name: 'No risk', value: 'none' },
    ];

    userSignInRiskLevelsLookup: LookupItem[] = [
        { name: 'High', value: 'high' },
        { name: 'Medium', value: 'medium' },
        { name: 'Low', value: 'low' },
    ];

    insiderRiskLevelsLookup: LookupItem[] = [
        { name: 'Elevated', value: 'elevated' },
        { name: 'Moderate', value: 'moderate' },
        { name: 'Minor', value: 'minor' },
    ];

    platFormsLookup: LookupItem[] = [
        { name: 'Android', value: 'android' },
        { name: 'iOS', value: 'iOS' },
        { name: 'Windows Phone', value: 'windowsPhone' },
        { name: 'Windows', value: 'windows' },
        { name: 'macOS', value: 'macOS' },
        { name: 'Linux', value: 'linux' },
    ];

    clientAppsLookup: LookupItem[] = [
        { name: 'Modern authentication clients' },
        { name: 'Browser', value: 'browser' },
        { name: 'Mobile apps and desktop clients', value: 'mobileAppsAndDesktopClients' },
        { name: 'Legacy authentication clients' },
        { name: 'Exchange ActiveSync clients', value: 'exchangeActiveSync' },
        { name: 'Other clients', value: 'other' },
    ];

    clientAppsLookupObject = mapLookupToObject(this.clientAppsLookup);

    authenticationFlowsLookup: LookupItem[] = [
        { name: 'Transfer methods' },
        { name: 'Device code flow', value: 'deviceCodeFlow' },
        { name: 'Authentication transfer', value: 'authenticationTransfer' },
    ];

    constructor() {}

    ngOnInit(): void {
        this.includePlatFormController.valueChanges.subscribe((res: string[]) => {
            if (res.length > 0) {
                this.excludePlatFormController.enable();
            } else {
                this.excludePlatFormController.setValue([]);
                this.excludePlatFormController.disable();
            }
        });
    }

    get userSignInRiskLevelsController(): FormControl {
        return this.conditionsController?.get('userRiskLevels') as FormControl;
    }
    get signInRiskLevelsController(): FormControl {
        return this.conditionsController?.get('signInRiskLevels') as FormControl;
    }
    get insiderRiskLevelsController(): FormControl {
        return this.conditionsController?.get('insiderRiskLevels') as FormControl;
    }

    get includePlatFormController(): FormControl {
        return this.conditionsController?.get('platforms')?.get('includePlatforms') as FormControl;
    }

    get excludePlatFormController(): FormControl {
        return this.conditionsController?.get('platforms')?.get('excludePlatforms') as FormControl;
    }

    get clientAppsController(): FormControl {
        return this.conditionsController?.get('clientAppTypes') as FormControl;
    }

    get authenticationFlowsController(): FormControl {
        return this.conditionsController?.get('authenticationFlows')?.get('transferMethods') as FormControl;
    }

    get authenticationFlowsStringValue(): string {
        const value = this.authenticationFlowsController?.value || [];
        return value.join(',');
    }

    get conditionsController(): FormGroup {
        return this.form.get('conditions') as FormGroup;
    }

    get transferMethodsCurrentValue() {
        const arrayItems = (this.policy?.conditions?.['authenticationFlows']?.transferMethods as string)?.split(',');

        return (
            arrayItems?.map((res) => this.authenticationFlowsLookup.find((item) => item.value === res)?.name || res) ||
            []
        );
    }

    get transferMethodsCurrentValueString(): string {
        return this.policy?.conditions?.['authenticationFlows']?.transferMethods || '';
    }
}
